export default "__VITE_ASSET__4C2ZMxlo__"